module.exports = __webpack_public_path__ + "static/img/theme_07.19773975.png";